import React from 'react'
import { FaArrowLeft } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

const AdminBackNavigation = ({ path, text, backHistory }) => {

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };
    return (
        <>
            {backHistory ?
                <button onClick={handleBack} className="d-inline-flex align-items-center gap-2 mb-3 theme-bg-color px-3 rounded-5 py-2 theme-text-color" id="backArrow" aria-label="Go back"                >
                    <FaArrowLeft className="fs-6 d-inline-block" /><span className="fw-medium">{text || 'Back'}</span>
                </button>
                :
                <Link to={path} className="d-inline-flex align-items-center gap-2 mb-3 theme-bg-color px-3 rounded-5 py-2" id="backArrow">
                    <FaArrowLeft className="fs-6 d-inline-block" /><span className="fw-medium">{text || 'Back'}</span>
                </Link>
            }
        </>
    )
}

export default AdminBackNavigation